import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["name", "title", "body", "professionalSignature", "patientSignature", "modal", "patientID"]

  open() {
    this.modalTarget.classList.remove("hide");
  }

  close() {
    this.modalTarget.classList.add("hide");
  }

  save() {
    let title = this.titleTarget.value;
    let body = this.bodyTarget.value;
    let professional_signature = this.professionalSignatureTarget.checked;
    let patient_signature = this.patientSignatureTarget.checked;
    let name = this.nameTarget.value;
    let patientID = this.patientIDTarget.value;

    $.ajax({
      url: "/establishment/saved_custom_documents",
      method: "POST" ,
      data: {title, body, professional_signature, patient_signature, name, patientID},
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
    }).done((data) => {
      $(this.containerTarget).append(data)
    })
  }
}
